import Vue from '../../../plugins/vueFactory';

export default {
  setBaseShapeData(state, payload) {
    state.baseShapeData = payload;
  },
  setBaseShapePriceData(state, payload) {
    state.baseShapePriceData.baseShape = payload.base_shape;
    state.baseShapePriceData.length = payload.length;
    state.baseShapePriceData.price = payload.price;

    Vue.set(
      state.baseShapePriceData,
      'messages',
      payload.messages?.map(x => ({
        message: x.message,
        severity: x.severity
      }))
    );

    Vue.set(
      state.baseShapePriceData,
      'products',
      payload.products.map(x => ({
        productCode: x.product_code,
        productUrl: x.product_url,
        longDescription: x.long_description,
        quantity: x.quantity,
        priceEach: x.price_each,
        discount: x.discount,
        subtotal: x.subtotal,
        delivery: x.delivery ?? {}
      }))
    );
  }
};
